<div class="navigation">
  <treo-vertical-navigation
    [navigation]="menuData"
    [inner]="true"
    [mode]="'side'"
    [opened]="true"
  ></treo-vertical-navigation>
</div>
